<script lang="ts">
  import { superForm } from 'sveltekit-superforms'
  import type { PageData } from './$types'

  let { data }: { data: PageData } = $props()

  // superForm intentionally captures the initial form payload and manages its
  // own reactivity, so the one-time read of `data.form` is correct here.
  // svelte-ignore state_referenced_locally
  const { form, errors, message, enhance, submitting } = superForm(data.form)
</script>

<div class="flex min-h-screen items-center justify-center p-4">
  <form method="POST" use:enhance class="card preset-filled-surface-100-900 w-full max-w-sm space-y-4 p-6">
    <header class="space-y-1">
      <h1 class="h3">Sona Admin</h1>
      <p class="text-surface-600-400 text-sm">Staff sign in</p>
    </header>

    {#if $message}
      <p class="text-error-500 text-sm" role="alert">{$message}</p>
    {/if}

    <label class="label">
      <span class="label-text">Email</span>
      <input
        class="input"
        type="email"
        name="email"
        autocomplete="username"
        bind:value={$form.email}
        aria-invalid={$errors.email ? 'true' : undefined}
      />
      {#if $errors.email}<span class="text-error-500 text-xs">{$errors.email}</span>{/if}
    </label>

    <label class="label">
      <span class="label-text">Password</span>
      <input
        class="input"
        type="password"
        name="password"
        autocomplete="current-password"
        bind:value={$form.password}
        aria-invalid={$errors.password ? 'true' : undefined}
      />
      {#if $errors.password}<span class="text-error-500 text-xs">{$errors.password}</span>{/if}
    </label>

    <button type="submit" class="btn preset-filled-primary-500 w-full" disabled={$submitting}>
      {$submitting ? 'Signing in…' : 'Sign in'}
    </button>
  </form>
</div>
